function bnr__block_slick(){
	$('.bnr__block').slick({
		dots: true
	});
}

function sidebar__slider_slick(){
	$('.sidebar__slider').slick({
		dots: false
	});
}

function bnr_slider_slick(){
	$('.bnr-slider').slick({
		dots: false
	});
}
function renderHref (state) {
	return $('<a href="'+state.id+'" class="sort-page">'+state.text+'</a>');
};
function select_init_ajax(){
	$('.select:not(.select-catalog)').select2();
	$('.select-catalog').select2(
		{
			templateResult:renderHref,
			closeOnSelect: false
		}
	);
	$('.select-catalog').on('select2:select', function (e) {
		window.location=$(e.params.originalEvent.currentTarget).children()[0].href;
	});
}

$(document).ready(function() {
	//slider
	$('.bnr__block').slick({
		lazyLoad: "ondemand",
		dots: true
	});

	$('.sidebar__slider').slick({
		lazyLoad: "ondemand",
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});

	$('.bnr-slider').slick({
		lazyLoad: "ondemand",
		dots: false
	});

	//menu
	$(".nav__trigger").on('click', function() {
		$("#w0").slideToggle("slow");
	});
	//plus minus
	$(document).on('click', '.minus', function () {
		var $input = $(this).parent().find('input');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		return false;
	});
	$(document).on('click', '.plus', function () {
		var $input = $(this).parent().find('input');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		return false;
	});
	//select
    // $('.select').select2();
    /*$('.select:not(.select-catalog)').select2();
	$('.select-catalog').select2(
		{
			templateResult:renderHref,
            closeOnSelect: false
		}
	);
    $('.select-catalog').on('select2:select', function (e) {
    	// debugger;
      window.location=$(e.params.originalEvent.currentTarget).children()[0].href;

        // Do something
    });*/

	select_init_ajax();

	//tab
	$('.tabs-nav a, .make-order__nav a').click(function(event){
		event.preventDefault();
		$('.tabs-nav a, .make-order__nav a').removeClass('active');
		$(this).addClass('active');
		$('.tab, .make-order__form').removeClass('active');
		$($(this).attr('href')).addClass('active');
	});

	//accordion
	$( ".cabinet__title" ).click(function() {
		$(this).next( ".cabinet__content" ).slideToggle( "slow" );
		$(this).toggleClass( "active" );
	});

	//search
	$( ".search-trigger" ).click(function() {
		$(this).next( ".search-block" ).toggleClass( "active" );
	});

	//lang
	$( ".head-top__lang-trigger" ).click(function() {
		$(this).toggleClass( "active" );
		$(this).next().slideToggle( 'fast' );
	});

	$('.nav__catalog').on('click', function(event) {
		event.preventDefault();
		$('#w1').slideToggle();
	});

	$('.search-trigger').on('click', function(event) {
		event.preventDefault();
	});

	$('.viber-btn').on('click', function (e){
		e.preventDefault();

		var viberNumber = parseInt('380955706689');

		/** Iphone */
		var agent = navigator.userAgent;
		var isIphone = ((agent.indexOf('iPhone') != -1) || (agent.indexOf('iPad') != -1)) ;

		if ($(window).width() < 991) {
			if (isIphone) {
				// ios
				$(location).attr('href', 'viber://chat?number=+' + viberNumber);
			} else {
				// others
				$(location).attr('href', 'viber://chat?number=' + viberNumber);
			}
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({'event': 'ClickViber'});
		} else {
			//desctop
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({'event': 'ClickViber'});
			$(location).attr('href', 'viber://chat?number=+' + viberNumber);
		}
	});

});

$(document).on('ajaxComplete', function (event) {
	bnr__block_slick();

	sidebar__slider_slick();

	bnr_slider_slick();

	select_init_ajax();

	if (typeof LazyLoad !== 'undefined') {
		new LazyLoad({
			elements_selector: ".lazy"
		});
	}
});
